import { useAppSelector } from '@/hooks/useRedux'
import { Navigate } from 'react-router-dom'

export default function ProtectedRoute({ element }: { element: React.ReactNode }) {
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{element}</>
}
